import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import { errorsMapping } from '../../mappers/errors-mapping.js';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-shipping-method.js';
import { SET_SHIPPING_STATE } from '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import { getFlattenedCartFailureErrorCodes } from '../../utils/get-flattened-cart-error-codes.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { useMutationConfig } from './use-mutation-config.js';

const useSetShippingState = ({ onError , onCompleted  } = {})=>{
    const { cart  } = Context.useCart();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React.useCallback((responseData)=>{
        let result;
        if ('setShippingState' in responseData) {
            var ref;
            result = responseData.setShippingState;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(result.cart.hasAlternativeShippingState ? result.cart.id : undefined);
            }
        }
    }, [
        onCompleted,
        onError
    ]);
    const handleOnError = React.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const [mutationCallback, mutation] = useMutation(SET_SHIPPING_STATE, swcHelpers.objectSpread({}, mutationOptions, {
        fetchPolicy: 'no-cache'
    }));
    /**
   *  Shipping state data update operation
   *  @param countryCode: string
   *  @param postalCode?: string
   */ const setShippingState = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(countryCode, postalCode) {
            const cartId = cart === null || cart === void 0 ? void 0 : cart.id;
            if (!cartId) {
                return;
            }
            yield mutationCallback({
                variables: {
                    shippingStateInput: {
                        cartId,
                        countryCode,
                        postalCode
                    }
                },
                refetchQueries: [
                    'GetCart',
                    'ShippingMethodsForCart'
                ]
            });
        });
        return function(countryCode, postalCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart === null || cart === void 0 ? void 0 : cart.id,
        mutationCallback
    ]);
    return {
        setShippingState,
        isUpdating: mutation.loading,
        updateError: mutation.error
    };
};

export { useSetShippingState };
//# sourceMappingURL=use-set-shipping-state.js.map
